import * as React from 'react'
import ReactDOM from 'react-dom'
import * as PopperJS from '@popperjs/core'
import { usePopper } from 'react-popper'
import { PositioningStrategy } from '@popperjs/core'

interface IProps {
  active: boolean
  activator: JSX.Element
  onClose?: () => void
  placement?: PopperJS.Placement
  children: React.ReactNode
  zIndex?: number | string
  strategy?: PositioningStrategy
  container: HTMLElement | null
}


const Popover = (props: IProps) => {
  const { activator, placement, active, onClose, children, strategy, container } = props
  const [referenceElement, setReferenceElement] = React.useState(null);
  const [popperElement, setPopperElement] = React.useState<HTMLDivElement>(null);
  const { styles, attributes, update } = usePopper(referenceElement, popperElement, {
    placement: placement,
    strategy: strategy,
  });

  const onOutsideClick = (e) => {
    if (active) {
      if (
        // Additional check for powerselect when click X
        // It gets removed from the DOM which causes the popover to close unintended
        container.contains(e.target) &&
        referenceElement && !referenceElement.contains(e.target) &&
        popperElement && !popperElement.contains(e.target)
      ) {
        if (onClose) onClose()
      }
    }
  }

  // Component did mount
  React.useEffect(() => {
    if (active) {
      if (update) update()
      container.addEventListener('mousedown', onOutsideClick);
    } else {
      container.removeEventListener('mousedown', onOutsideClick);
    }

    return () => {
      container.removeEventListener('mousedown', onOutsideClick);
    }
  }, [active, update])

  return (
    <>
      {React.cloneElement(activator, { ref: setReferenceElement })}

      {active && <>
        {ReactDOM.createPortal(<div
          ref={setPopperElement}
          style={{
            ...styles.popper,
            visibility: active ? 'visible' : 'hidden',
            pointerEvents: active ? 'all' : 'none',
            zIndex: props.zIndex ? props.zIndex : 999
          }}
          {...attributes.popper}
        >
          {children}
        </div>, container)}
      </>}
    </>
  )
}

export default Popover